import { useState, useEffect } from 'react'
import { useLocation } from '@/hooks/useLocation'
import { MapPin, X } from 'lucide-react'

interface LocationInputProps {
  value: string
  onChange: (value: string) => void
}

export function LocationInput({ value, onChange }: LocationInputProps) {
  const { location: autoLocation, loading } = useLocation()
  const [userEdited, setUserEdited] = useState(false)

  // Auto-fill when location detected, unless user already typed something
  useEffect(() => {
    if (autoLocation && !userEdited && !value) {
      onChange(autoLocation)
    }
  }, [autoLocation]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex w-full items-center gap-2 rounded-lg border border-border/60 bg-card px-3 py-2 focus-within:ring-2 focus-within:ring-primary/30">
      <MapPin size={16} className="text-muted-foreground shrink-0" />
      <input
        type="text"
        value={loading && !value ? '' : value}
        placeholder={loading ? 'Detecting location...' : 'Where was this? (optional)'}
        onChange={(e) => {
          setUserEdited(true)
          onChange(e.target.value)
        }}
        className="flex-1 bg-transparent text-sm text-foreground outline-none border-0"
      />
      {value && (
        <button
          type="button"
          onClick={() => {
            onChange('')
            setUserEdited(true)
          }}
          className="shrink-0 p-0.5 text-muted-foreground hover:text-foreground transition-colors"
        >
          <X size={14} />
        </button>
      )}
    </div>
  )
}
